export default __webpack_public_path__ + "wheelchair.png";